export const TableColumnHandlerKey = 'handler';
